import BudgetAndNetwork from './budget-and-network';
import Deliverables from './deliverables';
import Demographics from './demographics';
import InfluencerPackage from './influencer-package';
import Product from './product';
import Specialties from './specialties';

function Step() {}

Step.BudgetAndNetwork = BudgetAndNetwork;
Step.Demographics = Demographics;
Step.Specialties = Specialties;
Step.Deliverables = Deliverables;
Step.InfluencerPackage = InfluencerPackage;
Step.Product = Product;

export default Step;
